export default __webpack_public_path__ + "static/25-b057039ecc54aaa72607d16f14894cdf.png";